import { useTranslation } from 'react-i18next'

import { useDebouncedCallback } from '../../../../../../../../../../../../../../../../../../hooks/useDebouncedCallback'
import { useInvoiceEditorForm } from '../../../../../../../../../../../../../../contexts/invoiceEditorFormContext'
import { useIsCreditNoteFromDepositOrFinalInvoice } from '../../../../../../../../../../../../../../hooks/useIsCreditNoteFromDepositOrFinalInvoice'
import { useUpdateDependentLineValues } from '../../../../../../../../../../hooks/useUpdateDependentLineValues'
import { CurrencyInput } from '../../../../../../../../../CurrencyInput'
import { CommonInvoiceLineFieldProps } from '../../../../../../types/commonInvoiceLineFieldProps'

type InvoiceLineUnitPriceProps = CommonInvoiceLineFieldProps

export const InvoiceLineUnitPrice = ({ disabled = false, lineIndex }: InvoiceLineUnitPriceProps) => {
  const { t } = useTranslation()
  const { invoiceEditorForm, trackInvoiceEditor } = useInvoiceEditorForm()
  const { FormItem } = invoiceEditorForm
  const { handleUnitPriceChange } = useUpdateDependentLineValues()
  const isCreditNoteFromDepositOrFinalInvoice = useIsCreditNoteFromDepositOrFinalInvoice()

  const handleDebouncedInputNumberChange = useDebouncedCallback((price: number) =>
    trackInvoiceEditor('Form - Invoice lines - Price changed', {
      price,
    }),
  )

  return (
    <FormItem
      name={`invoiceLines.${lineIndex}.unitPrice`}
      render={({ field: { value, onChange, ...props } }) => {
        return (
          <CurrencyInput
            {...props}
            aria-label={t('external_invoices.editor.form.field.line.header.unit_price')}
            disabled={disabled || isCreditNoteFromDepositOrFinalInvoice}
            min={0}
            onChange={(unitPrice) => {
              handleUnitPriceChange(lineIndex, unitPrice)
              onChange(unitPrice)
              handleDebouncedInputNumberChange(unitPrice)
            }}
            value={value}
            size="sm"
          />
        )
      }}
    />
  )
}
